import { combineReducers } from 'redux';
import { authReducer, employeeLogReducer, myLeaveReducer, statsReducer, usersReducer } from './reducers';
import languageReducer from './reducers/languageReducer';
import estimationReducer from './reducers/estimationReducer';
import analyticsReducer from './reducers/analyticsReducer';
import analyticsFilterReducer from './reducers/analyticsFilterReducer';
const rootReducer = combineReducers({
    authReducer,
    employeeLogReducer,
    language: languageReducer,
    estimation: estimationReducer,
    users: usersReducer,
    leaveReducer: myLeaveReducer,
    stats: statsReducer,
    analytics: analyticsReducer,
    analyticsFilter: analyticsFilterReducer

})

export default rootReducer